/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Utils } from 'poly-js-utils';

import { connectToJSContext, getQueryStringParameterByName } from "../utils.jsx";

import Footer from "../footer/index.jsx";
import Navigation from "../navigation/index.jsx";
import EventList from "../event_list/index.jsx";
import { EventsOrgCustomContent, EventsUserCustomContent } from "../custom_content/index.jsx";
import { EventsHero } from "../hero/index.jsx";
import ContactForm from "../contact_form/index.jsx";
import { EVENTS_PAGE } from '../constants';

const getShouldShowContactForm = (events, selectedEventId, shouldHideContactFormOnEventListPage) => {
    if (!selectedEventId) {
        return !shouldHideContactFormOnEventListPage;
    }
    // double equal, due to string number type discrepancy
    // eslint-disable-next-line eqeqeq
    const [{ rsvp_type: rsvpType } = {}] = events.filter(({ id }) => selectedEventId == id);
    return rsvpType === 'form';
};

class EventsPage extends React.Component {
    constructor(props) {
        super(props);
        const { showOrgCustomContent, showUserCustomContent } = props;
        this.moduleComponentMap = {
            [EVENTS_PAGE.MODULES.EVENTS_HERO]: EventsHero,
            [EVENTS_PAGE.MODULES.EVENTS_ORG_CUSTOM_CONTENT]: showOrgCustomContent && EventsOrgCustomContent,
            [EVENTS_PAGE.MODULES.EVENTS_USER_CUSTOM_CONTENT]: showUserCustomContent && EventsUserCustomContent,
            [EVENTS_PAGE.MODULES.EVENT_LIST]: EventList,
            [EVENTS_PAGE.MODULES.EVENTS_CONTACT_FORM]: ContactForm
        };
        const selectedEventId = getQueryStringParameterByName('event');
        this.state = {
            selectedEventId
        };
        this.setSelectedEventId = this.setSelectedEventId.bind(this);
    }
    componentDidMount() {
        window.onpopstate = () => {
            const selectedEventId = getQueryStringParameterByName('event');
            this.setState(() => ({ selectedEventId }));
        };
    }
    componentWillUnmount() {
        window.onpopstate = () => undefined;
    }
    setSelectedEventId(selectedEventId) {
        window.scrollTo(0, 0);
        window.history.pushState(null, '', `?event=${selectedEventId}`);
        this.setState(() => ({ selectedEventId }));
    }
    render() {
        const { moduleOrder, events, shouldHideContactFormOnEventListPage } = this.props;
        const { selectedEventId } = this.state;
        return (
            <div>
                <Navigation currentPage={'events'}/>
                <div id="maincontent" role="main">
                    {moduleOrder.map((moduleName, moduleIndex) => {
                        const Component = this.moduleComponentMap[moduleName];
                        switch (moduleName) {
                            case EVENTS_PAGE.MODULES.EVENT_LIST:
                                return Component
                                    && <Component
                                        selectedEventId={selectedEventId}
                                        setSelectedEventId={this.setSelectedEventId}
                                        key={moduleIndex}
                                    />;
                            case EVENTS_PAGE.MODULES.EVENTS_CONTACT_FORM:
                                return Component
                                    && getShouldShowContactForm(
                                        events,
                                        selectedEventId,
                                        shouldHideContactFormOnEventListPage
                                    )
                                    && <Component
                                        key={moduleIndex}
                                        selectedEventId={selectedEventId}
                                    />;
                            default:
                                return Component
                                    && <Component key={moduleIndex} />;
                        }
                    })}
                </div>
                <Footer />
            </div>
        );
    }
}

EventsPage.defaultProps = {
    moduleOrder: [
        EVENTS_PAGE.MODULES.EVENTS_HERO,
        EVENTS_PAGE.MODULES.EVENTS_ORG_CUSTOM_CONTENT,
        EVENTS_PAGE.MODULES.EVENTS_USER_CUSTOM_CONTENT,
        EVENTS_PAGE.MODULES.EVENTS_CONTACT_FORM,
        EVENTS_PAGE.MODULES.EVENTS
    ]
};

EventsPage.propTypes = {
    showOrgCustomContent: PropTypes.bool.isRequired,
    showUserCustomContent: PropTypes.bool.isRequired,
    moduleOrder: PropTypes.arrayOf(
        PropTypes.oneOf(_.values(EVENTS_PAGE.MODULES))
    ).isRequired
};

const mapStateToProps = (state) => ({
    events: state.events,
    showOrgCustomContent: !_.isEmpty(state.theme_data.events_page.custom_content),
    showUserCustomContent: !_.isEmpty(state.profile.events_custom_content),
    moduleOrder: state.theme_data.events_page.modules &&
        _.flatten(_.pluck(state.theme_data.events_page.modules, 'module')),
    shouldHideContactFormOnEventListPage: Utils.selectBoxIsTrue(
        state.theme_data.events_page.should_hide_contact_form_on_event_list_page
    )
});

export default connectToJSContext(mapStateToProps)(EventsPage);



// WEBPACK FOOTER //
// ./components/events_page/index.jsx